import { render, staticRenderFns } from "./QuestionAuthentication.vue?vue&type=template&id=0c3b60b8&scoped=true"
import script from "./QuestionAuthentication.vue?vue&type=script&lang=js"
export * from "./QuestionAuthentication.vue?vue&type=script&lang=js"
import style0 from "./QuestionAuthentication.vue?vue&type=style&index=0&id=0c3b60b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3b60b8",
  null
  
)

export default component.exports